import React from 'react';

interface Props {
  className?: string;
}

export const Buck: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="16"
    viewBox="0 0 19 16"
    width="19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.74998 0V0.5V1.25C9.74998 1.66562 10.0844 2 10.5 2H11C11.4156 2 11.75 1.66562 11.75 1.25V0.5V0H12.75V0.5V1.25C12.75 1.51875 12.6906 1.77188 12.5812 2H13.5375H14.75C15.1656 2 15.5 1.66562 15.5 1.25V0.5V0H16.5V0.5V1.25C16.5 1.92813 16.1156 2.5125 15.5531 2.80625C15.5719 2.82188 15.5875 2.84063 15.6062 2.85625L17.75 5V7H14.75H14.5844L13.75 9.5V11.5V16H10.75V11.5H9.24998L7.24998 10.6438V10.75V11.3719L6.80935 11.8125L5.9781 12.6438L7.1656 16H3.98435L2.83435 12.75L2.52185 11.8562L3.1906 11.1875L4.0031 10.375L3.49998 9.87187C3.40623 9.77812 3.32185 9.68125 3.24685 9.575L3.1906 10.3031L1.69373 10.1875L1.74998 9.44063L1.82498 8.5C1.95623 6.80625 3.3656 5.5 5.0656 5.5H5.31248H5.74998H8.74998H11.2L11.5 4.5H9.74998V3.5L11.75 3H11H10.5C9.53435 3 8.74998 2.21563 8.74998 1.25V0.5V0H9.74998ZM14.25 5C14.525 5 14.75 4.775 14.75 4.5C14.75 4.225 14.525 4 14.25 4C13.975 4 13.75 4.225 13.75 4.5C13.75 4.775 13.975 5 14.25 5Z"
      fill="currentColor"
    />
  </svg>
);
